/* @refresh reload */
import { ColorModeProvider, ColorModeScript } from '@kobalte/core'
import { QueryClientProvider } from '@tanstack/solid-query'
import { Show } from 'solid-js'
import { render } from 'solid-js/web'

import { App } from './App.tsx'
import { LoginPage } from './components/LoginPage.tsx'
import { OAuthConsentPage } from './components/OAuthConsentPage.tsx'
import { Toaster } from './components/ui/Sonner.tsx'
import { authMe, isGuest } from './store/auth.ts'
import { queryClient } from './utils/query.ts'

import '@unocss/reset/tailwind-compat.css'
import 'virtual:uno.css'
import './app.css'

function Root() {
  return (
    <QueryClientProvider client={queryClient}>
      <ColorModeScript />
      <ColorModeProvider>
        <Toaster />
        {/*
          no <Suspense> around the app: solid-query's `.data` is a resource, so every
          uncached tree/file fetch would suspend and blank the whole page (folders
          especially, because expanding the sidebar tree fans out into many queries).

          gate on `!loading` rather than `authMe()?.authenticated` alone - while the
          me call is in flight that field is undefined and would flash the login page
          for people who are already signed in
        */}
        <Show when={!authMe.loading}>
          {/* a guest isn't authenticated, but if an admin opened some indexes to
              guests there is something to show them */}
          <Show when={authMe()?.authenticated || isGuest()} fallback={<LoginPage />}>
            {/* not one of the app's routes: you only ever land here from an mcp
                client's oauth flow, and leave by posting the form */}
            <Show when={location.pathname === '/oauth/consent'} fallback={<App />}>
              <OAuthConsentPage />
            </Show>
          </Show>
        </Show>
      </ColorModeProvider>
    </QueryClientProvider>
  )
}

render(() => <Root />, document.getElementById('root')!)
